import React, {Component} from "react";
import {translate} from "react-i18nify";

import imgClose from "../../../resources/img/svgicons/cancel2.svg";

import Button from "./Button";

/**
 * @class CancelButton
 *
 * Predefined generic button with cancel label and SVG
 *
 * [Confluence page]{@link https://deso.atlassian.net/wiki/spaces/Redlike/pages/52068383/CancelButton}
 *
 * @param {function} [onClick] -  called on click
 *
 * @example
 * <CancelButton onClick={this.handleCloseModalClick} />
 *
 */
export default class CancelButton extends Component {
    render() {
        return <Button {...this.props} label={translate("general.cancel")} svgBefore={imgClose} />;
    }
}
